import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "./Button";

const investData = [
  { id: 1, title: "Joshua Aryeequaye", image: "/invest1.png" },
  // { id: 5, title: "Sheila Sherifa Amadu", image: "/invest5.png" },

  { id: 2, title: "Nelson Kpatakpa", image: "/invest2.png" },
  { id: 4, title: "Pamela Elinam Oyeh", image: "/invest4.png" },

  { id: 3, title: "Jeremy Yeboah Boateng", image: "/invest3.png" },
];

const InvestC = () => {
  const navigate = useNavigate();
  return (
    <section className="padding">
      <div className="h-full md:w-[60%] w-full">
        <div className={`xs:mt-[20px] mt-[6px]`}>
          <Link
            to={"/about"}
            className="flex  items-center xs:mt-[16px] mt-[8px] xs:mb-[20px] mb-[20px]"
          >
            <img
              src="/images/arrow-left.svg"
              alt="arrow_blue"
              className="w-[20px] h-[20px] mb-[-5px] "
            />
            <p className="mediumF text-lightBlue text-[16px] underline hover:underline-darkGray cursor-pointer">
              About us
            </p>
          </Link>
        </div>
      </div>

      {/* Management */}
      <h1 className="text-center blue_gradient_text mt-[41px] md:text-[32px] sm:text-[25px] text-[20px] boldF leading-[38px]">
        Meet our Investment Advisors
      </h1>

      <section className="flex items-center  xs:mb-[20px] mb-[10px]">
        <h2 className="sm:text-[20px] text-[18px] sm:w-[220px] w-full boldF text-darkGray leading-[24px]">
          Investment Advisors
        </h2>
        <div className="bg-[#DCDDDD] w-[80%] h-[1px] md:block hidden mt-[4px]"></div>
      </section>

      <section className="flex justify-center flex-wrap md:gap-[30px] gap-[20px] py-[30px] max-w-[1000px] mx-auto">
        {investData.map((item) => (
          <div className="h-[320px] flex flex-col gap-[8px]" key={item.id}>
            <div className="h-[250px] ">
              <img
                src={item.image}
                alt="img"
                className="w-full h-full object-contain"
              />
            </div>
            <h2 className="text-darkGray mediumF xs:text-[18px] text-[16px] leading-[21px] capitalize text-center">
              {item.title}
            </h2>
          </div>
        ))}
      </section>
      <div className="flex items-center gap-[10px]  mb-[30px] flex-wrap">
        <div onClick={() => navigate("/key-people")}>
          <Button text={"Our Management"} icon={"/images/arrow-button.svg"} />
        </div>
        <div onClick={() => navigate("/board-of-directors")}>
          <Button
            text={"Our Board of Directors"}
            icon={"/images/arrow-button.svg"}
          />
        </div>
      </div>
    </section>
  );
};

export default InvestC;
